import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import "../../style/Account.css";
import { MDBBtn } from "mdbreact";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function MonCompte() {
  const loggedIn = useSelector((state) => state.login);
  const [redirect, setRedirect] = useState(false);
  const [email, setEmail] = useState();
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordbis, setNewPasswordbis] = useState("");
  const [disabledBtnEmail, setDisabledBtnEmail] = useState(false);
  const [disabledBtnNewPassword, setDisabledBtnNewPassword] = useState(false);
  const { addToast } = useToasts();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  const newPasswordField = (event) => {
    setNewPassword(event.target.value);
  };
  const newPasswordBisField = (event) => {
    setNewPasswordbis(event.target.value);
  };
  const emailField = (event) => {
    setEmail(event.target.value);
  };

  useEffect(() => {
    function getEmailAddress() {
      axios
        .get(`${API_URL}/api/user/email`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => res.data)
        .then((data) => {
          setEmail(data);
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setRedirect(true);
          }
        });
    }

    if (loggedIn) {
      getEmailAddress();
    }
  }, []);

  const handleSubmitEmail = (event) => {
    event.preventDefault();
    setDisabledBtnEmail(true);
    axios
      .put(
        `${API_URL}/api/user/email`,
        { email },
        {
          headers: { authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          addToast("Votre adresse mail a été mise à jour", {
            appearance: "success",
            autoDismiss: true,
          });
          setRedirect(true);
        }
      })
      .catch((err) =>
        addToast("Problème lors de la mise à jour de l'adresse mail", {
          appearance: "error",
          autoDismiss: true,
        })
      );
  };
  const handleSubmitNewPassword = (event) => {
    event.preventDefault();
    setDisabledBtnNewPassword(true);
    axios
      .put(
        `${API_URL}/api/user/password`,
        { newPassword },
        {
          headers: { authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          addToast("Votre mot de passe a été mis à jour", {
            appearance: "success",
            autoDismiss: true,
          });
          setRedirect(true);
        }
      })
      .catch((err) =>
        addToast("Problème lors de la mise à jour du mot de passe", {
          appearance: "error",
          autoDismiss: true,
        })
      );
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Mon Compte</title>
      </Helmet>
      <h1>Mon compte</h1>
      {redirect && <Redirect to="/" />}
      <div className="accountContainer">
        <div className="accountFrame">
          <h4>Modifier mon adresse mail</h4>
          <form
            action=""
            method="post"
            className="accountForm"
            onSubmit={handleSubmitEmail}
          >
            <label for="email">Mon adresse mail :</label>
            <input
              placeholder="Entrez votre adresse mail"
              id="email"
              name="email"
              type="email"
              value={email}
              onChange={emailField}
            />
            <MDBBtn
              color="primary"
              type="submit"
              className="accountBtn"
              value="submit"
              disabled={disabledBtnEmail}
            >
              Enregistrer
            </MDBBtn>
          </form>
        </div>
        <div className="accountFrame">
          <h4>Modifier mon mot de passe</h4>
          <form
            action=""
            method="post"
            className="accountForm"
            onSubmit={handleSubmitNewPassword}
          >
            <label for="newPassword">
              Nouveau mot de passe (8 caractères minimum):
            </label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              placeholder="Nouveau mot de passe"
              value={newPassword}
              onChange={newPasswordField}
              required
            />
            <label for="newPasswordbis">Confirmation du mot de passe :</label>
            <input
              type="password"
              id="newPasswordbis"
              name="newPasswordbis"
              placeholder="Confirmation du mot de passe"
              value={newPasswordbis}
              onChange={newPasswordBisField}
              required
            />
            <MDBBtn
              color="primary"
              type="submit"
              className="accountBtn"
              value="submit"
              disabled={
                newPassword === newPasswordbis && newPassword.length >= 7
                  ? disabledBtnNewPassword
                  : true
              }
            >
              Enregistrer
            </MDBBtn>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MonCompte;
